import "moment/locale/de";
import moment from "moment";
import { momentLocalizer } from "react-big-calendar";
import { TransformedEvent } from "../Utils/ParsingUtil";

export const localizer = momentLocalizer(moment);

export const germanTranslations = {
  today: "Aktueller Monat",
  previous: "Vorheriger Monat",
  next: "Nächster Monat",
  month: "Monatsansicht",
  agenda: "Listenansicht",
  date: "Datum",
  time: "",
  event: "Ereignis",
  noEventsInRange: "Es gibt keine Termine innerhalb des angegebenen Zeitraums.",
  allDay: "ganztägig",
  more: "mehr",
  showMore: (total: Number) => `+ ${total} weitere`,
};

export const initValue: TransformedEvent = {
  title: "Termin nicht gefunden",
  start: new Date(2023, 11, 11),
  end: new Date(2023, 11, 11),
  allDay: false,
  resource: {
    longTitle: 'Titel',
    description: "Terminbeschreibung nicht vorhanden",
    link: [""],
    topic: "Mitarbeiter & Gehalt",
  },
};

export const initialSelectedCheckboxes = [
  "Mitarbeiter & Gehalt",
  "Steuern",
  "Buchhaltung & Finanzen",
  "Unternehmensführung",
];

export const getColor = (category: string) => {
  if (category === "Mitarbeiter & Gehalt") {
    return "#4699D4";
  } else if (category === "Steuern") {
    return "#EB6005";
  } else if (category === "Buchhaltung & Finanzen") {
    return "#ff4454";
  } else if (category === "Unternehmensführung") {
    return "#000000";
  } else {
    return "#DC4F4F";
  }
};

export const initPdfIntroData = { 
  "untertitel": "Damit Sie 2024 nichts verpassen",
  "einleitung": "Wann muss die Abgabe der Umsatzsteuervoranmeldung erfolgen? Wann sind die Sozialversicherungsbeiträge fällig? Ab wann gilt der neue Mindestlohn? Als Unternehmer müssen Sie das ganze Jahr hindurch unglaublich viele Termine auf dem Schirm haben. Mit dem Lexware Unternehmerkalender helfen wir Ihnen dabei, dass Sie künftig keinen Termin versäumen. Damit haben Sie die wichtigsten Termine für Ihr Unternehmen immer im Blick:" ,
  "themen": {
    "Steuern": "Abgabefristen für Umsatz- und Gewerbesteuer, Steuererklärungen und weitere steuerrelevante Ereignisse.",
    "Buchhaltung & Finanzen": "Stichtage für Jahresabschlüsse, relevante Gesetzesänderungen und andere wichtige Buchhaltungstermine.",
    "Mitarbeiter & Gehalt": "Termine für Beitragsnachweise und Bescheinigungen, Stichtage bei der Sozialversicherung sowie Abgabe- und Meldefristen.",
    "Unternehmensführung": "Gesetzesänderungen, die Ihr Unternehmen betreffenkönnen, Tipps zu staatlichen Förderungen oder strategische Planungshilfen."
  },
  "fusszeile": {
    "von": "Benjamin Franklin",
    "zitat": "Das Geheimnis des Erfolgs ist die richtige Planung."
  }
}